<template>
  <!-- 成员选择 -->
  <zs-custom-select
    v-model="memberNameList"
    class="w100"
    @search="selectMember"
    @handleDelete="deleteMember"
    :disabled="disabled"
  ></zs-custom-select>
</template>

<script>
import memberGroup from '@/components/dialog/memberGroup'
import zsCustomSelect from '@/components/zsCustomSelect'
import { mapActions } from 'vuex'
export default {
  components: {
    zsCustomSelect
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 权限类型
    authType: {
      type: Number,
      default: null
    },
    // 项目采购单位
    caiGouDanWei: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      allMemberList: [],
      memberNameList: [],
      authTypeNew: null
    }
  },
  created() {
    // authType 10  合同管理 20 集采询单 30 小额 采购  40 订单管理
    let authType = this.authType
    if (this.authType === 20) { // 集采询单 小额采购
      const inquiryBillType = this.$route.query.inquiryBillType
      authType = +inquiryBillType === 2 ? 20 : 30
    }
    this.authTypeNew = authType
    this.queryUserByQiYeGuid({
      qiYeGuid: this.$store.state.userInfo.corpId,
      authType: authType
    }).then((res) => {
      this.allMemberList = res
      this.setNameList(this.value)
    })
  },
  watch: {
    value(n) {
      this.setNameList(n)
    }
  },
  methods: {
    ...mapActions(['queryUserByQiYeGuid']),
    setNameList(val) {
      if (val) {
        this.memberNameList = this.allMemberList
          .filter((t) => val.split(',').indexOf(t.user_Guid) > -1)
          .map((t) => t.user_Name)
      } else {
        this.memberNameList = []
      }
    },
    // 选择项目组成员
    selectMember() {
      if (!this.caiGouDanWei) {
        this.$message.error('单位名称不能为空！')
        return false
      }
      this.$zl.dialog.openFull(memberGroup, {
        args: this.value,
        authType: this.authTypeNew,
        caiGouDanWei: this.caiGouDanWei,
        allMemberList: this.allMemberList
      }).then((result) => {
        this.$emit('input', result)
      })
    },
    deleteMember(row, index) {
      let projectUser = this.value.split(',')
      projectUser.splice(index, 1)
      this.$emit('input', projectUser.join(','))
    }
  }
}
</script>

<style></style>
